var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 259.5 293.28",
    style: {
      enableBackground: "new 0 0 259.5 293.28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#197CCE;}\n\t.st1{fill:#F9A23A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M259.5,140.66v-0.12c0-77.61-62.9-140.52-140.5-140.54C53.28,0.02,0,53.31,0,119.05h0.03 c0,47.04,28.17,87.51,68.57,105.44c-26.31-15.86-43.9-44.72-43.9-77.68c0-50.06,40.58-90.64,90.64-90.64 c50.06,0,90.64,40.58,90.64,90.64c0,27.55-12.29,52.22-31.68,68.84l-6.45-9.21l-9.63,54.63l54.63,9.63l-6.84-9.77 C238.85,231.29,259.5,188.39,259.5,140.66z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.42,66.8c-1.15,0-2.09,0.94-2.09,2.09v12.53c0,1.15,0.94,2.09,2.09,2.09c1.15,0,2.09-0.94,2.09-2.09 V68.89C117.5,67.73,116.57,66.8,115.42,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M94.7,69.53c-1.11,0.3-1.78,1.44-1.48,2.56l3.24,12.11c0.3,1.11,1.44,1.78,2.56,1.48 c1.11-0.3,1.78-1.44,1.48-2.56L97.25,71C96.96,69.89,95.81,69.23,94.7,69.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.39,77.52c-1,0.58-1.34,1.85-0.76,2.85l6.27,10.85c0.58,1,1.85,1.34,2.85,0.76c1-0.58,1.34-1.85,0.76-2.85 l-6.27-10.85C77.67,77.29,76.39,76.95,75.39,77.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.81,90.24c-0.82,0.82-0.82,2.14,0,2.95l8.86,8.86c0.82,0.82,2.14,0.82,2.95,0c0.82-0.82,0.82-2.14,0-2.95 l-8.86-8.86C60.95,89.43,59.63,89.43,58.81,90.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.09,106.82c-0.58,1-0.23,2.28,0.76,2.85l10.85,6.27c1,0.58,2.28,0.23,2.85-0.76 c0.58-1,0.23-2.28-0.76-2.85l-10.85-6.27C47.94,105.48,46.67,105.82,46.09,106.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.09,126.13c-0.3,1.11,0.36,2.26,1.48,2.56l12.11,3.24c1.11,0.3,2.26-0.36,2.56-1.48 c0.3-1.11-0.36-2.26-1.48-2.56l-12.11-3.24C39.54,124.35,38.39,125.02,38.09,126.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.36,146.85c0,1.15,0.94,2.09,2.09,2.09h12.53c1.15,0,2.09-0.94,2.09-2.09c0-1.15-0.94-2.09-2.09-2.09 H37.45C36.3,144.76,35.36,145.7,35.36,146.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.09,167.57c0.3,1.11,1.44,1.78,2.56,1.48l12.11-3.24c1.11-0.3,1.78-1.44,1.48-2.56 c-0.3-1.11-1.44-1.78-2.56-1.48l-12.11,3.24C38.45,165.31,37.79,166.45,38.09,167.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.09,186.87c0.58,1,1.85,1.34,2.85,0.76l10.85-6.27c1-0.58,1.34-1.85,0.76-2.85 c-0.58-1-1.85-1.34-2.85-0.76l-10.85,6.27C45.85,184.6,45.51,185.87,46.09,186.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.81,203.45c0.82,0.82,2.14,0.82,2.95,0l8.86-8.86c0.82-0.82,0.82-2.14,0-2.95c-0.82-0.82-2.14-0.82-2.95,0 l-8.86,8.86C58,201.31,58,202.64,58.81,203.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.39,216.17c1,0.58,2.28,0.23,2.85-0.76l6.27-10.85c0.58-1,0.23-2.28-0.76-2.85 c-1-0.58-2.28-0.23-2.85,0.76l-6.27,10.85C74.05,214.32,74.39,215.6,75.39,216.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.44,216.17c1-0.58,1.34-1.85,0.76-2.85l-6.27-10.85c-0.58-1-1.85-1.34-2.85-0.76 c-1,0.58-1.34,1.85-0.76,2.85l6.27,10.85C153.16,216.41,154.44,216.75,155.44,216.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.02,203.45c0.82-0.82,0.82-2.14,0-2.95l-8.86-8.86c-0.82-0.82-2.14-0.82-2.95,0 c-0.82,0.82-0.82,2.14,0,2.95l8.86,8.86C169.88,204.27,171.2,204.27,172.02,203.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.74,186.87c0.58-1,0.23-2.28-0.76-2.85l-10.85-6.27c-1-0.58-2.28-0.23-2.85,0.76 c-0.58,1-0.23,2.28,0.76,2.85l10.85,6.27C182.89,188.22,184.16,187.87,184.74,186.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.74,167.57c0.3-1.11-0.36-2.26-1.48-2.56l-12.11-3.24c-1.11-0.3-2.26,0.36-2.56,1.48 c-0.3,1.11,0.36,2.26,1.48,2.56l12.11,3.24C191.29,169.34,192.44,168.68,192.74,167.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.47,146.85c0-1.15-0.94-2.09-2.09-2.09h-12.53c-1.15,0-2.09,0.94-2.09,2.09c0,1.15,0.94,2.09,2.09,2.09 h12.53C194.53,148.94,195.47,148,195.47,146.85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.74,126.13c-0.3-1.11-1.44-1.78-2.56-1.48l-12.11,3.24c-1.11,0.3-1.78,1.44-1.48,2.56 c0.3,1.11,1.44,1.78,2.56,1.48l12.11-3.24C192.38,128.39,193.04,127.24,192.74,126.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.74,106.82c-0.58-1-1.85-1.34-2.85-0.76l-10.85,6.27c-1,0.58-1.34,1.85-0.76,2.85 c0.58,1,1.85,1.34,2.85,0.76l10.85-6.27C184.98,109.1,185.32,107.82,184.74,106.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.02,90.24c-0.82-0.82-2.14-0.82-2.95,0l-8.86,8.86c-0.82,0.82-0.82,2.14,0,2.95 c0.82,0.82,2.14,0.82,2.95,0l8.86-8.86C172.84,92.38,172.84,91.06,172.02,90.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.44,77.52c-1-0.58-2.28-0.23-2.85,0.76l-6.27,10.85c-0.58,1-0.23,2.28,0.76,2.85 c1,0.58,2.28,0.23,2.85-0.76l6.27-10.85C156.78,79.38,156.44,78.1,155.44,77.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.13,69.53c-1.11-0.3-2.26,0.36-2.56,1.48l-3.24,12.11c-0.3,1.11,0.36,2.26,1.48,2.56 c1.11,0.3,2.26-0.36,2.56-1.48l3.24-12.11C137.91,70.97,137.25,69.82,136.13,69.53z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.28,238.53H89.4c-5.5,0-9.95,4.46-9.95,9.95c0,5.5,4.46,9.95,9.95,9.95h51.88c5.5,0,9.95-4.46,9.95-9.95 C151.23,242.99,146.78,238.53,141.28,238.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M121.91,273.37h-13.14c-5.5,0-9.95,4.46-9.95,9.95s4.46,9.95,9.95,9.95h13.14c5.5,0,9.95-4.46,9.95-9.95 S127.41,273.37,121.91,273.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.14c821f4537465bcfdaf537313d28d88.svg";
export { ForwardRef as ReactComponent };